module.exports = __webpack_public_path__ + "img/back_arrow.10abec1d.svg";